























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import { subscriptionActivityRulesConfigFields } from '@/config/activity-rules-config';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcDatepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import BpcTextarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSwitchWithDescription from '@shared/components/forms/inputs/switch-with-description.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';

import {
  SubscriptionActivityRulesConfig,
  SubscriptionActivityRulesConfigErrorsObject,
} from '@subscriptions/interfaces/subscription-category';

@Component({
  name: 'bpc-subscription-activity-rules-config-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcDatepicker,
    BpcInputGroup,
    BpcTextarea,
    BpcSwitch,
    BpcEntitySelect,
    BpcSwitchWithDescription,
    BpcSection,
  },
})
export default class SubscriptionOnlineBookingConfigForm extends Vue {
  @Prop(Object) readonly value: SubscriptionActivityRulesConfig;
  @Prop(Array) readonly disciplinesForOnlineBookingIds: number[];
  @Prop(Array) readonly resourcesForOnlineBookingIds: number[];

  loading = false;
  errorsObject: SubscriptionActivityRulesConfigErrorsObject = {};

  get formModel() {
    return this.value;
  }

  set formModel(value: SubscriptionActivityRulesConfig) {
    this.$emit('input', value);
  }

  get noLabel() {
    return {
      labelAttributes: {
        for: 'no_label',
      },
    };
  }

  get fieldsConfig() {
    return subscriptionActivityRulesConfigFields;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }

  get maxWeeklyActiveAttendeesDescriptionItems() {
    return [
      {
        name: this.$t('centers.subscriptions.activity_rules_config.max_weekly_active_attendees'),
        description: this.$t(
          'centers.subscriptions.activity_rules_config.max_weekly_active_attendees_description',
        ),
        id: 'centers.subscriptions.activity_rules_config.max_weekly_active_attendees',
      },
    ];
  }

  resetFormModel() {
    this.formModel = {
      max_weekly_active_attendees: '0',
      max_global_active_attendees: '0',

      defaultValueSwitchModel: {
        max_weekly_active_attendees: false,
        max_global_active_attendees: false,
      },
    };
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, errors[key]);
    });
  }

  @Watch('formModel', { deep: true })
  onFormModelChange() {
    this.$emit('formModelChange', this.formModel);
  }
}
